// extracted by mini-css-extract-plugin
export default {"root":"_3kc5L","body-wrapper":"_1T8-E","bodyWrapper":"_1T8-E","big":"_2U3JH","postfix":"_3v_Qr","small":"_2x5Gt","multiline":"_7qk_6","body-node":"_2gxAf","bodyNode":"_2gxAf"};